class AnnualLeasingAmount {
    numberOfBricks;
    estimatedLeasingAmount;
    constructor(data) {
        this.numberOfBricks = data.numberOfBricks;
        this.estimatedLeasingAmount = data.estimatedLeasingAmount;
    }
}
export default AnnualLeasingAmount;
